export var PAGE_TYPES;
(function(PAGE_TYPES) {
    PAGE_TYPES["PAGES"] = "pages";
    PAGE_TYPES["ROOT"] = "root";
    PAGE_TYPES["APP"] = "app";
})(PAGE_TYPES || (PAGE_TYPES = {}));

//# sourceMappingURL=page-types.js.map